import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Trans, translate } from 'react-i18next';

import { formatCurrency } from 'helpers/format';

export const ReferralCode = ({ t, referralCoupon }) => {
  const referralBonus = formatCurrency(
    parseFloat(referralCoupon.referralBonus, 10),
    referralCoupon.referralBonusCurrency
  );

  return (
    <div className="aside__item">
      <h4>{t('overview.referralCode.heading')}</h4>

      <h5 className="aside__value">{referralCoupon.coupon.code}</h5>

      <Trans
        className="aside__description"
        i18nKey="overview.referralCode.description"
      >
        <Link to="/get-discount">Earn more credits</Link> by telling people
        about your experience with Freska. Sharing referral code you can give
        {{ referralBonus }} discount of the first cleaning to as many friends as
        you like.
      </Trans>
    </div>
  );
};

ReferralCode.propTypes = {
  t: PropTypes.func.isRequired,
  referralCoupon: PropTypes.object.isRequired
};

export default translate()(ReferralCode);



// WEBPACK FOOTER //
// ./src/components/ReferralCode/ReferralCode.js